import React from 'react';

/**
 * The yellow submit button every auth form ends with. While `busy` it swaps its label for a
 * spinner and `busyLabel` (the button stays the same size, so the card does not jump) and is
 * disabled, so a second click cannot send the request twice.
 * Anything else (`disabled`, `onClick`, ...) goes to the <button>.
 */
function AuthSubmit({ busy = false, label, busyLabel, disabled = false, ...buttonProps }) {
  return (
    <button type="submit" className="auth-submit" disabled={busy || disabled} {...buttonProps}>
      {busy ? (
        <span className="auth-submit-loading">
          <span className="auth-spinner" aria-hidden="true" />
          {busyLabel}
        </span>
      ) : label}
    </button>
  );
}

export default AuthSubmit;
